/* unplugin-vue-components disabled */import script from "./partBottom.vue?vue&type=script&setup=true&lang=ts"
export * from "./partBottom.vue?vue&type=script&setup=true&lang=ts"

import "./partBottom.vue?vue&type=style&index=0&id=2be0ebf4&scoped=true&lang=less"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@4.9.5__webpack@5.106.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2be0ebf4"]])

export default __exports__